import { Link } from "react-router-dom";
import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

// KEEP OLD PROJECT IMAGES (UNCHANGED)
import BlockChainDevelopment from "../../images/serviceSection/Blockchain Services/Blockchain Development.png";
import BlockchainConsulting from "../../images/serviceSection/Blockchain Services/Blockchain Consulting.png";
import Ecommerce from "../../images/serviceSection/Blockchain Services/E-commerce Blockchain.png";
import Cardano from "../../images/serviceSection/Blockchain Services/Cardano Blockchain Development.png";
import Education from "../../images/serviceSection/Blockchain Services/Education Blockchain.png";
import Ethereum from "../../images/serviceSection/Blockchain Services/Ethereum Blockchain Development.png";
import HealthCare from "../../images/serviceSection/Blockchain Services/Healthcare Blockchain.png";
import LayerB2 from "../../images/serviceSection/Blockchain Services/Layer 2 Blockchain Development.png";
import LayerC2 from "../../images/serviceSection/Blockchain Services/Layer 2 Cryptocurrency Development.png";
import NodeSales from "../../images/serviceSection/Blockchain Services/Node Sale Services.png";
import SmartContract from "../../images/serviceSection/Blockchain Services/Smart Contract Audit.png";
import SocialMedia from "../../images/serviceSection/Blockchain Services/Social Media Blockchain.png";
import Solana from "../../images/serviceSection/Blockchain Services/Solana Blockchain Development.png";
import Transport from "../../images/serviceSection/Blockchain Services/Transportation Blockchain.png";
import Supply from "../../images/serviceSection/Blockchain Services/Supply Chain Blockchain.png";



// SAME ARROW ICON (UNCHANGED)
const ArrowIcon = () => (
  <>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>

    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>
  </>
);

// 🔑 MEGAMENU-6 → PAGE DATA
const megaProjects = [
  {
    title: "Blockchain Development",
    content:
      "End-to-end blockchain development services including dApps, smart contracts, enterprise blockchain solutions, and decentralized platforms.",
    link: "/blockchain-development",
    images: [BlockChainDevelopment, BlockChainDevelopment, BlockChainDevelopment, BlockChainDevelopment],
    reverse: false,
  },
  {
    title: "Blockchain Consulting",
    content:
      "Expert blockchain consulting to design architecture, select platforms, and ensure scalability, security, and compliance.",
    link: "/blockchain-consulting",
    images: [BlockchainConsulting, BlockchainConsulting, BlockchainConsulting, BlockchainConsulting],
    reverse: true,
  },
  {
    title: "E-commerce Blockchain",
    content:
      "Blockchain-powered e-commerce solutions enabling secure payments, transparent supply chains, and trust-based marketplaces.",
    link: "/ecommerce-blockchain-development",
    images: [Ecommerce, Ecommerce, Ecommerce, Ecommerce],
    reverse: false,
  },
  {
    title: "Healthcare Blockchain",
    content:
      "Healthcare blockchain solutions for secure medical records, interoperability, data privacy, and patient-centric systems.",
    link: "/healthcare-blockchain-development",
    images: [HealthCare, HealthCare, HealthCare, HealthCare],
    reverse: true,
  },
  {
    title: "Transportation Blockchain",
    content:
      "Blockchain solutions for logistics and transportation to improve traceability, automation, and operational efficiency.",
    link: "/transportation-blockchain-development",
    images: [Transport, Transport, Transport, Transport],
    reverse: false,
  },
  {
    title: "Education Blockchain",
    content:
      "Blockchain-based education platforms for credential verification, digital certificates, and transparent academic records.",
    link: "/education-blockchain-development",
    images: [Education, Education, Education, Education],
    reverse: true,
  },
  {
    title: "Social Media Blockchain",
    content:
      "Decentralized social media platforms with data ownership, privacy control, and tokenized engagement models.",
    link: "/social-media-blockchain-development",
    images: [SocialMedia, SocialMedia, SocialMedia, SocialMedia],
    reverse: false,
  },
  {
    title: "Smart Contract Audit",
    content:
      "Comprehensive smart contract auditing services to detect vulnerabilities and ensure secure blockchain deployments.",
    link: "/smart-contract-audit",
    images: [SmartContract, SmartContract, SmartContract, SmartContract],
    reverse: true,
  },
  {
    title: "Node Sale Services",
    content:
      "Node sale platforms and services to support decentralized networks, validator onboarding, and fundraising.",
    link: "/node-sale-services",
    images: [NodeSales, NodeSales, NodeSales, NodeSales],
    reverse: false,
  },
  {
    title: "Solana Blockchain Development",
    content:
      "High-performance Solana blockchain development for scalable dApps, DeFi platforms, and NFT ecosystems.",
    link: "/solana-blockchain-development",
    images: [Solana, Solana, Solana, Solana],
    reverse: true,
  },
  {
    title: "Cardano Blockchain Development",
    content:
      "Cardano-based blockchain solutions leveraging peer-reviewed research and secure smart contract frameworks.",
    link: "/cardano-blockchain-development",
    images: [Cardano, Cardano, Cardano, Cardano],
    reverse: false,
  },
  {
    title: "Ethereum Blockchain Development",
    content:
      "Ethereum development services for smart contracts, DeFi, NFTs, and enterprise-grade blockchain applications.",
    link: "/ethereum-blockchain-development",
    images: [Ethereum, Ethereum, Ethereum, Ethereum],
    reverse: true,
  },
  {
    title: "Layer 2 Blockchain Development",
    content:
      "Layer 2 blockchain solutions to improve scalability, reduce gas fees, and enhance transaction throughput.",
    link: "/layer2-blockchain-development",
    images: [LayerB2, LayerB2, LayerB2, LayerB2],
    reverse: false,
  },
  {
    title: "Layer 2 Cryptocurrency Development",
    content:
      "Custom Layer 2 cryptocurrency development focused on performance optimization and seamless integration.",
    link: "/layer2-cryptocurrency-development",
    images: [LayerC2, LayerC2, LayerC2, LayerC2],
    reverse: true,
  },
  {
    title: "Supply Chain Blockchain",
    content:
      "Blockchain-based supply chain solutions enabling transparency, traceability, and fraud prevention.",
    link: "/supply-chain-blockchain-development",
    images: [Supply, Supply, Supply, Supply],
    reverse: false,
  },
];

const BlockchainServicesPage: React.FC = () => {
  return (
    <Fragment>
      <div className="service-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle
              pageTitle="Blockchain Services"
              pagesub="Enterprise, Web3 & Industry Solutions"
            />

            <section className="service pos-rel">
              <div className="container mxw-1650">
                <div className="xb-project-wrap xb-project-wrap_2">

                  {megaProjects.map((item, index) => (
                    <div className="xb-project-item" key={index}>

                      {!item.reverse ? (
                        <>
                          <div className="xb-project-content">
                            <div className="xb-item--inner xb-border">
                              <h2 className="xb-item--title">{item.title}</h2>
                              <p className="xb-item--content clr-white">{item.content}</p>

                              <div className="xb-item--btn mt-40">
                                <Link className="thm-btn agency-btn" to={item.link}>
                                  <span className="text">Explore</span>
                                  <span className="arrow">
                                    <span className="arrow-icon"><ArrowIcon /></span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>

                          <div className="xb-project-img img-hove-effect">
                            <div className="xb-img">
                              {item.images.map((img, i) => (
                                <Link to={item.link} key={i}>
                                  <img src={img} alt="service" />
                                </Link>
                              ))}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="xb-project-img img-hove-effect">
                            <div className="xb-img">
                              {item.images.map((img, i) => (
                                <Link to={item.link} key={i}>
                                  <img src={img} alt="service" />
                                </Link>
                              ))}
                            </div>
                          </div>

                          <div className="xb-project-content">
                            <div className="xb-item--inner xb-border">
                              <h2 className="xb-item--title">{item.title}</h2>
                              <p className="xb-item--content clr-white">{item.content}</p>

                              <div className="xb-item--btn mt-40">
                                <Link className="thm-btn agency-btn" to={item.link}>
                                  <span className="text">Explore</span>
                                  <span className="arrow">
                                    <span className="arrow-icon"><ArrowIcon /></span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                    </div>
                  ))}

                </div>
              </div>
            </section>

          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default BlockchainServicesPage;
